import { InvoiceStatus } from '@libs/schemas/src/invoice';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export const InvoiceStatusBadge = ({
  status,
  className,
  reason,
}: {
  status: InvoiceStatus;
  className?: string;
  reason?: string;
}) => {
  const getStatusColor = (status: InvoiceStatus) => {
    switch (status) {
      case InvoiceStatus.PAID:
        return 'bg-green-100 text-green-800 hover:bg-green-200 hover:text-green-900';
      case InvoiceStatus.PAYMENT_FAILED:
        return 'bg-red-100 text-red-800 hover:bg-red-200 hover:text-red-900';
      case InvoiceStatus.OVERDUE:
        return 'bg-orange-100 text-orange-800 hover:bg-orange-200 hover:text-orange-900';
      case InvoiceStatus.DRAFT:
        return 'bg-gray-100 text-gray-800 hover:bg-gray-200 hover:text-gray-900';
      case InvoiceStatus.SENT:
        return 'bg-blue-100 text-blue-800 hover:bg-blue-200 hover:text-blue-900';
      case InvoiceStatus.CANCELLED:
        return 'bg-red-100 text-red-800 hover:bg-red-200 hover:text-red-900';
      case InvoiceStatus.PARTIALLY_PAID:
        return 'bg-yellow-100 text-yellow-800 hover:bg-yellow-200 hover:text-yellow-900';
      default:
        return 'bg-gray-100 text-gray-800 hover:bg-gray-200 hover:text-gray-900';
    }
  };

  return (
    <div className="flex items-center gap-1">
      <Badge
        className={cn(
          `py-[2px] px-[8px] rounded-lg h-fit w-fit capitalize`,
          getStatusColor(status),
          className,
        )}
      >
        {status}
      </Badge>
      {reason && (
        <div className="text-xs text-muted">
          <span>{reason}</span>
        </div>
      )}
    </div>
  );
};
